import { render, staticRenderFns } from "./ReachCard.vue?vue&type=template&id=10adf60c"
import script from "./ReachCard.vue?vue&type=script&lang=js"
export * from "./ReachCard.vue?vue&type=script&lang=js"
import style0 from "./ReachCard.vue?vue&type=style&index=0&id=10adf60c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports